// ONLY SCRIPTS THAT WILL ATTEND THE ENTIRE SITE
// Add a spinner and disable the search button in the header, while the search page is loading
const headerSearchForm = document.getElementById("searchForm");
const headerSearchButton = document.getElementById("submitButton");
if (headerSearchForm && headerSearchButton) {
    headerSearchForm.addEventListener("submit", () => {
        const searchIcon = headerSearchButton.querySelector(".fa.fas.fa-search");
        if (searchIcon)
            searchIcon.style.display = "none";
        headerSearchButton.disabled = true;
        const spinner = headerSearchButton.querySelector(".loading-spinner");
        if (spinner)
            spinner.style.display = "inline-block";
    });
}
// Listening for the pageshow event — which fires when the page is loaded from bfcache (back browser button) — and reset UI state (spinner and disabled buttons)
window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
        // Reset <button> elements
        const buttons = document.querySelectorAll(".spinner-button");
        buttons.forEach(button => {
            button.disabled = false;
            const spinner = button.querySelector(".loading-spinner");
            if (spinner)
                spinner.style.display = "none";
        });
        // Reset <a> elements with loading spinners
        const anchorElements = document.querySelectorAll(".spinner-anchor");
        anchorElements.forEach(anchor => {
            anchor.classList.remove("loading");
            anchor.style.pointerEvents = ""; // Reset pointer events
            const spinner = anchor.querySelector(".loading-spinner");
            if (spinner)
                spinner.style.display = "none";
        });
        // Putting back the original icon replaced by the spinner
        const searchIcon = document.querySelectorAll(".spinner-button .fa.fas.fa-search,.spinner-button .search-icon");
        searchIcon.forEach(icon => {
            icon.style.display = "inline-block";
        });
    }
});
